export default __webpack_public_path__ + "static/media/lab_icon.11e7eee9.svg";